import { render, staticRenderFns } from "./BidDashboardChartsPanel.vue?vue&type=template&id=9608935c&scoped=true"
import script from "./BidDashboardChartsPanel.vue?vue&type=script&lang=js"
export * from "./BidDashboardChartsPanel.vue?vue&type=script&lang=js"
import style0 from "./BidDashboardChartsPanel.vue?vue&type=style&index=0&id=9608935c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9608935c",
  null
  
)

export default component.exports